import { Breadcrumb, Switch, Timeline } from "antd";
import { t } from "i18next";
import { CloseIcon, ActiveDotIcon, InactiveDotIcon, BackIcon } from "../../../asset";
import style from './addressFormatConfigPage.module.css'
import CustomTable from "../../../component/table/CustomTable";
import PrimaryButton from "../../../component/button/PrimaryButton";
import { useState } from "react";
import SecondaryButton from "../../../component/button/SecondaryButton";
import Breadcumbs from '../../../component/page-components/breadcumbs/breadcumbs';


export default function AddressFormatConfigEdit() { 

  const AddressFormatConfigurationColumn = [
    {
      title: (
        <span className="font-roboto text-lg text-[#222222]">
          {t("ADDRESS_FORMAT_CONFIG:FIELD_FIELD")}
        </span>
      ),
      dataIndex: 'field',
      key: 'field',
      render: (field) => <span>{field}</span>,
    },
    {
      title: (
        <span className="font-roboto text-lg text-[#222222]">
          {t("ADDRESS_FORMAT_CONFIG:LABEL_FIELD")}
        </span>
      ),
      dataIndex: 'label',
      key: 'label',
      render: (label) => <span>{label}</span>,
    },
    {
      title: (
        <span className="font-roboto text-lg text-[#222222]">
          {t("ADDRESS_FORMAT_CONFIG:SHOW_FIELD")}
        </span>
      ),
      dataIndex: 'show',
      key: 'show',
      render: (show) => <span>{show}</span>,
    },
    {
      title: (
        <span className="font-roboto text-lg text-[#222222]">
          {t("ADDRESS_FORMAT_CONFIG:MANDATORY_FIELD")}
        </span>
      ),
      dataIndex: 'mandatory',
      key: 'mandatory',
      render: (mandatory) => <span>{mandatory}</span>,
    },
    {
      title: (
        <span className="font-roboto text-lg text-[#222222]">
          {t("ADDRESS_FORMAT_CONFIG:CONSIDER_FOR_GEOCODING_FIELD")}
        </span>
      ),
      dataIndex: 'geocoding',
      key: 'geocoding',
      render: (geocoding) => <span>{geocoding}</span>,
    },
  ]

  const dataSource = [
    {
      field: (
        <span className="font-roboto text-lg text-[#222222]">
          Apartment
        </span>
      ),
      label: (
        <span className="font-roboto text-lg text-[#222222]">
          Apartment
        </span>
      ),
      show: (
        <span className="font-roboto text-lg text-[#222222] flex items-center gap-[8px]">
          <Switch defaultChecked/>
          <label>Yes</label>
        </span>
      ),
      mandatory: (
        <span className="font-roboto text-lg text-[#222222] flex items-center gap-[8px]">
          <Switch defaultChecked/>
          <label>Yes</label>
        </span>
      ),
      geocoding: (
        <span className="font-roboto text-lg text-[#222222] flex items-center gap-[8px]">
          <Switch defaultChecked/>
          <label>Yes</label>
        </span>
      ),
    }
  ]

  return (
    <div className='p-[24px] flex flex-col gap-[24px]'>

        <Breadcumbs
          jmlLevel={4}
          menuLevel1={`Setup`}
          menuLevel2={`Profile Configuration`}
          menuLevel3={`Address Format Configuration`}
          menuLevel4={`Edit Address Format Configuration`}
        />

      <div className="flex gap-[22px] items-center">
          <img src={BackIcon} alt="" className='cursor-pointer' />
        <h1 className='font-sans-bold text-2xl' id='title'>{t("ADDRESS_FORMAT_CONFIG:EDIT_TITLE")}</h1>
      </div>

      <div className={style.tableContainer}>

        <CustomTable showPagination={false} columns={AddressFormatConfigurationColumn} data={dataSource} />

      </div>

      <div className="flex justify-start flex-row-reverse gap-[16px]">
        <PrimaryButton text={t("ADDRESS_FORMAT_CONFIG:SAVE")} />
        <SecondaryButton text={t("ADDRESS_FORMAT_CONFIG:CANCEL")}/>
      </div>
    </div>
  );
}

